module.exports = __webpack_public_path__ + "img/IMG_9458_59_60_L_Wood.a197af56.jpg";